import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
import { Eyebrow } from './Eyebrow';
const terms = ['Wystarczy jeden e-mail', 'Żadnych formularzy', 'Pobrane pliki zostają u Ciebie'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="bg-night py-16 sm:py-24" data-id="element-165" data-mp="22124nbc614rz">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-166" data-mp="1x28qdgp219qr">
        <div className="grid gap-8 rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,20rem)] lg:gap-16" data-id="element-167" data-mp="19fsjehclycip">
          <div data-id="element-168" data-mp="1j4k6oc6q48na">
            <div className="flex items-center gap-4" data-id="element-169" data-mp="1j4aj0v95idkr">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber" data-id="element-170" data-mp="1j5vcehjqbqh1">
                <ShieldCheckIcon className="h-6 w-6 text-night" aria-hidden="true" data-id="element-171" data-mp="1ebr3vtutfadu" />
              </span>
              <Eyebrow data-id="element-172" data-mp="qlwqnb6l3jt2">Zero ryzyka &middot; 100% ochrony</Eyebrow>
            </div>
            <h2 id="guarantee-heading" className="mt-6 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-173" data-mp="lowlr3lh0n3j">
              10-dniowa <span className="text-amber" data-id="element-174" data-mp="txkvr892ng27">gwarancja zwrotu pieniędzy</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-cream-soft" data-id="element-175" data-mp="yp2vxu39tcm4">
              Otwórz wszystko. Korzystaj z materiałów. Przetestuj je na prawdziwych zajęciach. Jeśli
              Arsenał nie zmieni sposobu, w jaki planujesz i uczysz, napisz na{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-amber underline decoration-amber/40 underline-offset-2 transition-colors duration-150 ease-out hover:text-amber-light" data-id="element-176" data-mp="azqlys04d0ir">
                {SUPPORT_EMAIL}
              </a>{' '}
              w ciągu 10 dni od zakupu, a zwrócimy całe $27 &mdash; nie musisz niczego tłumaczyć, a
              pobrane pliki zostają u Ciebie.
            </p>
          </div>
          <div className="flex flex-col justify-center border-t border-night-600 pt-8 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-177" data-mp="1vhol0doai0z2">
            <ul className="space-y-3" data-id="element-178" data-mp="3nhoapsz58jli">
              {terms.map(term => <li key={term} className="text-sm uppercase tracking-label text-cream-soft" data-id="element-179" data-mp="5bibzskgzr1h">
                  {term}
                </li>)}
            </ul>
            <p className="mt-8 font-serif text-xl italic leading-snug text-amber-light" data-id="element-180" data-mp="d8f9dj3kidr">
              Zwroty realizujemy w ciągu 2 dni roboczych.
            </p>
          </div>
        </div>
      </div>
    </section>;
}